import { render, staticRenderFns } from "./toolsRank.vue?vue&type=template&id=035a61b9&scoped=true&"
import script from "./toolsRank.vue?vue&type=script&lang=js&"
export * from "./toolsRank.vue?vue&type=script&lang=js&"
import style0 from "./toolsRank.vue?vue&type=style&index=0&id=035a61b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035a61b9",
  null
  
)

export default component.exports